import { render, staticRenderFns } from "./ToProfitList.vue?vue&type=template&id=08db2b1a&"
import script from "./ToProfitList.vue?vue&type=script&lang=js&"
export * from "./ToProfitList.vue?vue&type=script&lang=js&"
import style0 from "./ToProfitList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports